const sectionBannerBasicB1Css = `
[data-type='section-banner-basic-b1'] .wrapper-container {
  color: var(--text-color, #000000);
  position: relative;
}

[data-type='section-banner-basic-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 120px;
}

[data-type='section-banner-basic-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 120px;
}

[data-type='section-banner-basic-b1'] .background-section {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

[data-type='section-banner-basic-b1'] .background-section-mobile {
  display: none;
}

[data-type='section-banner-basic-b1'] .overlay-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

[data-type='section-banner-basic-b1'] .wrap-content {
  position: relative;
  padding: 22px 24px;
  z-index: 10;
  max-width: 640px;
  margin: 0 auto;
  border-radius: 20px;
}

[data-type='section-banner-basic-b1'] .wrap-content[data-align='left'] {
  margin-left: 0;
}

[data-type='section-banner-basic-b1'] .wrap-content[data-align='right'] {
  margin-right: 0;
}

[data-type='section-banner-basic-b1'] .content-title {
  font-size: 24px;
  font-weight: bold !important;
  margin: 0 0 30px 0 !important;
}

[data-type='section-banner-basic-b1'] .list-item > :not([hidden]) ~ :not([hidden]) {
  margin-top: 16px;
}

[data-type='section-banner-basic-b1'] .list-item .item {
  display: flex;
  gap: 18px;
  align-items: center;
  font-size: 18px;
}

[data-type='section-banner-basic-b1'] .list-item .item .icon {
  width: 36px;
}

[data-type='section-banner-basic-b1'] .list-item .item .icon img {
  display: block;
  width: 100%;
  height: auto;
}

@container (max-width: 768px) {
  [data-type='section-banner-basic-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 400px;
  }

  [data-type='section-banner-basic-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 15px;
  }

  [data-type='section-banner-basic-b1'] .background-section {
    display: none;
  }

  [data-type='section-banner-basic-b1'] .background-section-mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  [data-type='section-banner-basic-b1'] .wrap-content {
    max-width: 100%;
  }

  [data-type='section-banner-basic-b1'] .content-title {
    font-size: 20px;
    line-height: 24px;
  }
}

@container (max-width: 640px) {
  [data-type='section-banner-basic-b1'] .list-item .item {
    font-size: 16px;
  }
}
`;
export default sectionBannerBasicB1Css;
